import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, FreeMode, Thumbs } from "swiper/modules";
import "swiper/css";

export const slider = (): void => {
  console.log("slider");
  const topMvEl = document.querySelector(".p-top-mv-slider");
  if (topMvEl) {
    const mvDelay = 2500;
    const mvInitialDelay = 5000; // ロード後1枚目を表示する時間（この秒数経過後に2枚目へ。2枚目以降は mvDelay）
    const mvStartTime = performance.now();
    const mvLog = (label: string, detail?: Record<string, unknown>) => {
      const elapsed = Math.round(performance.now() - mvStartTime);
      console.log(`[mv-slider] +${elapsed}ms ${label}`, detail ?? "");
    };

    let mvFirstTransitionDone = false;
    const topMvSwiper = new Swiper(topMvEl as HTMLElement, {
      modules: [Autoplay, EffectFade],
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: mvInitialDelay,
        disableOnInteraction: false,
      },
      effect: "fade",
      speed: 2000,
      on: {
        init(swiper) {
          mvLog("init", {
            activeIndex: swiper.activeIndex,
            realIndex: swiper.realIndex,
            firstDelay: mvInitialDelay,
            thenDelay: mvDelay,
          });
        },
        slideChangeTransitionStart(swiper) {
          mvLog("slideChangeTransitionStart", {
            from: swiper.previousIndex,
            to: swiper.activeIndex,
            realIndex: swiper.realIndex,
          });
        },
        slideChangeTransitionEnd(swiper) {
          if (!mvFirstTransitionDone) {
            mvFirstTransitionDone = true;
            if (swiper.params.autoplay && typeof swiper.params.autoplay === "object") {
              swiper.params.autoplay.delay = mvDelay;
              swiper.autoplay.stop();
              swiper.autoplay.start();
            }
            mvLog("first transition done, delay set to", { delay: mvDelay });
          }
          mvLog("slideChangeTransitionEnd", {
            activeIndex: swiper.activeIndex,
            realIndex: swiper.realIndex,
          });
        },
      },
    });
  }
  const topImageEl = document.querySelector(".p-top-about-slider__swiper");
  if (topImageEl) {
    new Swiper(topImageEl as HTMLElement, {
      modules: [Autoplay, EffectFade],
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      effect: "fade",
      speed: 2000,
    });
  }
  const topPlacesEl = document.querySelector(".p-top-places-list__swiper");
  if (topPlacesEl) {
    new Swiper(topPlacesEl as HTMLElement, {
      modules: [Autoplay, Navigation],
      loop: true,
      slidesPerView: 5,
      centeredSlides: true,
      spaceBetween: 20,
      speed: 1000,
      autoplay: {
        delay: 20000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".p-top-places-list__btn.--next",
        prevEl: ".p-top-places-list__btn.--prev",
      },
      breakpoints: {
        980: {
          slidesPerView: 5,
        },
        850: {
          slidesPerView: 4,
        },
        576: {
          slidesPerView: 3,
        },
        375: {
          slidesPerView: 1.4,
        },
        320: {
          slidesPerView: 1,
        },
      },
    });
  }
  const aboutSliderEl = document.querySelector(".p-about-slider__swiper");
  if (aboutSliderEl) {
    new Swiper(aboutSliderEl as HTMLElement, {
      modules: [Autoplay],
      loop: true,
      slidesPerView: 3, // ← SCSSで幅指定するので auto
      spaceBetween: 30, // 画像の余白調整
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
  const worksSliderEl = document.querySelector(".p-top-works-slider");
  const worksNavNext = document.querySelector(".p-top-works__nav--next");
  const worksNavPrev = document.querySelector(".p-top-works__nav--prev");
  if (worksSliderEl && worksNavNext && worksNavPrev) {
    new Swiper(worksSliderEl as HTMLElement, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: false,
      speed: 500,
      navigation: {
        nextEl: worksNavNext as HTMLElement,
        prevEl: worksNavPrev as HTMLElement,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
        699: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  }
  const aboutImageSliders = document.querySelectorAll(".p-top-about-image-slider__swiper");
  aboutImageSliders.forEach((sliderEl, index) => {
    setTimeout(() => {
      const slideCount = (sliderEl as HTMLElement).querySelectorAll(".swiper-slide").length;
      const useLoop = slideCount >= 2;
      new Swiper(sliderEl as HTMLElement, {
        modules: [Autoplay, EffectFade],
        loop: useLoop,
        slidesPerView: 1,
        speed: 1000,
        effect: "fade",
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      });
    }, index * 1600);
  });
  const singleGalleryEl = document.querySelector(".p-single-gallery");
  const singleGalleryNavEl = document.querySelector(".p-single-gallery-nav__slider");
  if (singleGalleryEl && singleGalleryNavEl) {
    const slidesPerView = 4;
    const minSlidesForLoop = slidesPerView * 2;
    const navWrapper = singleGalleryNavEl.querySelector(".swiper-wrapper");
    const mainWrapper = singleGalleryEl.querySelector(".swiper-wrapper");

    if (navWrapper && mainWrapper) {
      while (navWrapper.children.length < minSlidesForLoop) {
        Array.from(navWrapper.children).forEach((slide) => {
          navWrapper.appendChild(slide.cloneNode(true));
        });
        Array.from(mainWrapper.children).forEach((slide) => {
          mainWrapper.appendChild(slide.cloneNode(true));
        });
      }
    }

    const singleGalleryNav = new Swiper(singleGalleryNavEl as HTMLElement, {
      loop: true,
      slidesPerView,
      loopAdditionalSlides: slidesPerView,
      spaceBetween: 24,
      speed: 500,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });
    const singleGallerySlider = new Swiper(singleGalleryEl as HTMLElement, {
      modules: [Navigation, EffectFade, Thumbs],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: false,
      speed: 500,
      effect: "fade",
      thumbs: { swiper: singleGalleryNav },
      navigation: {
        prevEl: ".p-single-gallery-nav__prev",
        nextEl: ".p-single-gallery-nav__next",
      },
    });

    // メインが変わったらナビのアクティブを合わせる（ボタン・サムネイルクリックどちらでも）
    let isSyncingFromMain = false;
    singleGallerySlider.on("slideChangeTransitionStart", () => {
      if (isSyncingFromMain) return;
      isSyncingFromMain = true;
      singleGalleryNav.slideToLoop(singleGallerySlider.realIndex, 500);
      setTimeout(() => { isSyncingFromMain = false; }, 550);
    });
  }
};
